import { createElementFromHTML, tryParseJSON } from '../../js/helper';
import { AjaxLoader } from './../../js/ajax-loader';
import 'formdata-polyfill';
import { sendTracking } from './../../js/tracking';

class IdForm {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-idform',
            fieldSelector: 'data-input',
            fieldAttr: 'field',
            inputAttr: 'input',
            resultAttr: 'result',
            resetAttr: 'reset',
            urlAttr: 'data-url',
            targetAttr: 'data-target',
            loader: null
        };

        this.settings = Object.assign({}, defaults, options);

        this.$formHandler = element;
        this.$header = document.querySelector('[data-header="root"]');

        if (this.settings.loader !== null) {
            this.$loader = createElementFromHTML(this.settings.loader);
        }

        this.$inputDelete = this.$formHandler.querySelector('.input-delete');
        this.$form = this.$formHandler.querySelector('form');

        this.initialize();
    }

    initialize () {
        this.setEvents();

        this.initFormFields();
        this.formStatus = this.checkField();
    }

    checkField () {
        const $input = this.$formHandler.querySelector('[' + this.settings.initAttr + '="' + this.settings.inputAttr + '"]');
        let $button = this.$formHandler.querySelector('button[type="submit"]');

        if ($button === null) {
            $button = this.$formHandler.querySelector('[' + this.settings.urlAttr + ']');
        }

        let status = false;

        if ($input.value === '') {
            $button.setAttribute('disabled', true);
        } else {
            $button.removeAttribute('disabled');
            status = true;
        }

        return status;
    }

    initFormFields () {
        const $field = this.$formHandler.querySelector('[' + this.settings.fieldSelector + ']');
        if ($field !== null) {
            import('../../components/form/form-input').then(({ FormInput }) => {
                const formAPI = new FormInput($field);
                $field.API = formAPI;
            });

            const $input = $field.querySelector('[' + this.settings.initAttr + '="' + this.settings.inputAttr + '"]');

            $input.addEventListener('keyup', () => {
                this.formStatus = this.checkField();
            });
        }
    }

    submitForm ($form) {
        let formAction = null;
        let formMethod = 'GET';
        let formData = null;
        let queryString = '?';
        let $button = null;

        if ($form) {
            $button = $form.querySelector('[type="submit"]');
        }

        if ($button === null) {
            $button = this.$formHandler.querySelector('[' + this.settings.urlAttr + ']');
        }

        if ($button) {
            $button.setAttribute('disabled', true);
            $button.appendChild(this.$loader);
        } else {
            $form.appendChild(this.$loader);
        }

        const $field = this.$formHandler.querySelector('[' + this.settings.initAttr + '="' + this.settings.fieldAttr + '"]');
        const $input = this.$formHandler.querySelector('[' + this.settings.initAttr + '="' + this.settings.inputAttr + '"]');
        const $formHelper = $field.querySelector('.form__helper');

        if ($form) {
            formAction = $form.getAttribute('action');
            formMethod = $form.getAttribute('method');
            formData = new FormData($form);

            if (formMethod.toLowerCase() === 'get') {
                for (const entry of formData.entries()) {
                    if (entry[1] !== '') {
                        queryString += encodeURIComponent(entry[0]) + '=' + encodeURIComponent(entry[1]) + '&';
                    }
                }
                queryString = queryString.slice(0, -1);
                formAction = formAction + queryString;
            }
        } else {
            formAction = $button.getAttribute(this.settings.urlAttr);

            const idValue = $input.value;
            formAction = formAction + idValue;
        }

        this.formResult = new AjaxLoader(formAction, {
            requestMethod: formMethod,
            requestData: formData,
            onSuccess: (resultText) => {
                if (this.$loader !== null) {
                    this.$loader.parentNode.removeChild(this.$loader);
                }

                const result = tryParseJSON(resultText);

                if (result !== false) {
                    if (result.success === true) {
                        const target = this.$formHandler.getAttribute(this.settings.targetAttr);
                        if (target) {
                            const $targetField = document.querySelector(target);
                            if ($targetField) {
                                $targetField.value = result.product;

                                const $formField = $targetField.closest('.form-element');

                                if ($formField) {
                                    if ($formField.classList.contains('has--error')) {
                                        $formField.classList.remove('has--error');
                                    }
                                }
                            }

                            const targetMatNr = this.$formHandler.getAttribute('data-target-matnr');
                            const targetDtswissId = this.$formHandler.getAttribute('data-target-dtswiss-id');

                            if (targetMatNr && targetDtswissId) {
                                const $targetMatNrField = document.querySelector(targetMatNr);
                                const $targetDtswissIdField = document.querySelector(targetDtswissId);

                                if ($targetMatNrField && $targetDtswissIdField) {
                                    $targetMatNrField.value = result.matnr;
                                    $targetDtswissIdField.value = result.dswiss_id;
                                }
                            }
                        } else {
                            window.location.href = result.url;
                        }
                    } else {
                        if (result.error) {
                            if ($formHelper) {
                                const $error = createElementFromHTML('<p>' + result.error + '</p>');
                                $formHelper.innerHTML = '';
                                $formHelper.appendChild($error);
                            }
                        }
                        $field.classList.add('has--error');
                    }
                } else {
                    $field.classList.add('has--error');
                }
            }
        });
    }

    setEvents () {
        const $input = this.$formHandler.querySelector('[' + this.settings.initAttr + '="' + this.settings.inputAttr + '"]');
        const $button = this.$formHandler.querySelector('[' + this.settings.urlAttr + ']');

        if (this.$form) {
            this.$form.addEventListener('submit', (e) => {
                if (this.checkField() === true) {
                    if (e.target.tagName.toLowerCase() === 'form') {
                        const trackingData = {
                            category: 'product support DT Swiss ID',
                            action: 'submit',
                            label: 'send btn ' + $input.value
                        };
                        sendTracking(trackingData);

                        this.submitForm(e.target);
                    }
                }
                e.preventDefault();
            });
        }

        $input.addEventListener('keyup', (e) => {
            window.stopFormSubmit = true;
            if (e.key === 'Enter') {
                if (this.checkField() === true) {
                    const trackingData = {
                        category: 'product support DT Swiss ID',
                        action: 'submit',
                        label: 'send btn ' + $input.value
                    };
                    sendTracking(trackingData);
                    const $form = this.$formHandler.querySelector('form');

                    if ($form) {
                        this.submitForm($form);
                    } else {
                        this.submitForm();
                    }
                    window.stopFormSubmit = false;
                }
            } else {
                window.stopFormSubmit = false;
            }
        });

        $input.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                window.stopFormSubmit = true;
            }
        });

        if ($button) {
            $button.addEventListener('click', (e) => {
                if (this.checkField() === true) {
                    const trackingData = {
                        category: 'product support DT Swiss ID',
                        action: 'submit',
                        label: 'send btn ' + $input.value
                    };
                    sendTracking(trackingData);
                    this.submitForm();
                }
            });
        }

        if (this.$inputDelete) {
            this.$inputDelete.addEventListener('click', () => {
                const $inputToEmpty = this.$formHandler.querySelector('input');
                $inputToEmpty.value = '';
                const $formElement = this.$inputDelete.closest('.form__element');
                $formElement.classList.remove('has--error');
            });
        }
    }
}

export { IdForm };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $idForm = $context.querySelector('[data-idform="root"]');
        const $productSupport = $context.querySelector('[data-product-support-url]');

        if ($idForm && $productSupport) {
            const idForm = new IdForm($idForm, { // eslint-disable-line
                loader: window.OPTIONS.loader
            });
        }
    }
});
